// Flow types automatically removed

import CheckmarkCircleIcon from 'dibs-icons/exports/legacy/CheckmarkCircle.ts';
import classnames from 'classnames';
import stepInspirationStyles from '../styles/FormStepInspiration.scss';

function _onCheck(state, onChange) {
    return function () {
        onChange(state);
    };
}

export const PictureSelection = ({
    name,
    imageInput,
    checkmarkNeeded,
    checked,
    selectedStyle,
    originalStyle,
    onChange,
}) => {
    const checkmarkClass = checked ? stepInspirationStyles.show : stepInspirationStyles.hide;
    const newValue = !name ? imageInput : name;
    const styling = classnames(stepInspirationStyles.icon, {
        [selectedStyle]: checked,
        [originalStyle]: !checked,
    });
    let body = null;

    if (typeof imageInput === 'string') {
        const image = {
            backgroundImage: `url("${imageInput}")`,
        };
        body = <div className={styling} style={image} onClick={_onCheck(newValue, onChange)} />;
    } else {
        body = (
            <div className={styling} onClick={_onCheck(newValue, onChange)}>
                {imageInput}
            </div>
        );
    }

    return (
        <div className={stepInspirationStyles.pictureDiv}>
            {checkmarkNeeded ? <CheckmarkCircleIcon className={checkmarkClass} /> : null}
            {body}
        </div>
    );
};
